window.scrollToError = function() {
  const firstError = $('.error-message:first');
  if(firstError.length > 0){
    window.scrollTo({ top: $(firstError).offset().top - (window.innerHeight / 3), behavior: 'smooth' });
  }
}

window.scrollToChapter = function(id) {
  const chapter = $(`#${id}`);
  if(chapter.length > 0){
    window.scrollTo({ top: $(chapter).offset().top - (window.innerHeight / 6), behavior: 'smooth' });
  }
}

window.scrollToHighlighted = function(id) {
  const firstHighlighted = $('.is-highlighted:first');
  if(firstHighlighted.length > 0){
    window.scrollTo({ top: $(firstHighlighted).offset().top - (window.innerHeight / 3), behavior: 'smooth' });
  }
}

window.scrollToRefutable = function(dom_id) {
  const refutable = $(`[data-refutable="${dom_id}"]`);
  if(refutable.length > 0){
    window.scrollTo({ top: $(refutable).offset().top - (window.innerHeight / 3), behavior: 'smooth' });
  }
}

